import axios from 'axios';

import { getAuthTokenFromStorage } from '../utils';
import { getServerUrl } from '../constants';

const SUBROUTE = 'flagged-link';

/**
 * @description gets all flagged links
 * @returns {Promise<Object>} API response
 */
export const fetchAll = async () => {
  if (!global.API_URL) {
    global.API_URL = getServerUrl();
  }

  const url = `${global.API_URL}/${SUBROUTE}`;

  try {
    const { data: { data } } = await axios.get(url);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

/**
 * @description creates a flagged link object in the database
 * @param {Object} fields object with data to send
 * @param {String} fields.link link to flag
 * @param {String} fields.reason reason for flagging
 * @returns {Object} api response
 */
export const createFlaggedLink = async (fields) => {
  const url = `${global.API_URL}/${SUBROUTE}`;
  const token = getAuthTokenFromStorage();

  try {
    const { data: { data } } = await axios.post(url, fields, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

/**
 * @description deletes a flagged link object
 * @param {String} id id of flagged link object
 * @returns {Promise<Object>} API response
 */
export const deleteFlaggedLink = async (id) => {
  if (!global.API_URL) {
    global.API_URL = getServerUrl();
  }

  const url = `${global.API_URL}/${SUBROUTE}/${id}`;
  const token = getAuthTokenFromStorage();

  try {
    const { data: { data } } = await axios.delete(url, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
